import { FoodsTags } from "@foodpilot/foods";
import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { ActionPlanTemplate } from "src/api/client-api/actionPlanTemplates/useActionPlanTemplates";

export const TemplateStatusBadge = (props: { status: ActionPlanTemplate["status"] }) => {
    const { status } = props;
    const theme = useTheme();
    const { t } = useTranslation();

    const labels = {
        draft: t("settings.action_plan_templates.status.draft", "Draft"),
        published: t("settings.action_plan_templates.status.published", "Published"),
        archived: t("settings.action_plan_templates.status.archived", "Archived"),
    };

    const colors = {
        draft: {
            background: theme.custom.yellow[50],
            foreground: theme.custom.yellow[700],
        },
        published: {
            background: theme.custom.green[50],
            foreground: theme.custom.green[700],
        },
        archived: {
            background: theme.custom.grey[400],
            foreground: theme.custom.grey[2500],
        },
    };

    return (
        <FoodsTags
            label={labels[status]}
            sx={{ whiteSpace: "nowrap", minWidth: "max-content", alignSelf: "flex-start" }}
            colors={colors[status]}
        />
    );
};
